<template>
  <b-container fluid>
    <b-row class="mb-5 mt-3">
      <b-col lg="3">
        <!-- <h5>Ajouts</h5> -->
        <div class="border-bottom mt-3 mb-3">
          <b-button
            v-b-modal.modal-categories
            variant="primary"
            block
            class="mb-3"
          >
            Catégories
          </b-button>
          <b-button
            variant="primary"
            block
            class="mb-3"
            @click="openQuestionModal()"
          >
            Nouvelle vérification
          </b-button>
        </div>
        <h5>Filtres</h5>
       
        <b-button
          @contextmenu.prevent.stop="handlerRightClick($event, component)"
          class="mr-1 mb-1"
          v-for="component in components"
          :key="component.id"
          @click="selectComponent(component)"
          >{{ component.name }}</b-button
        >
      </b-col>

      <b-col lg="9">
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Filter"
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button @click="getAll" class="mr-1">All</b-button>
            <b-button
              :variant="dark ? 'dark' : 'light'"
              @click="dark = !dark"
              class="mr-1"
              ><b-icon :icon="dark ? 'sun' : 'moon'" aria-hidden="true"></b-icon
            ></b-button>
          </b-col>
        </b-row>
        <b-table
          striped
          hover
          responsive
          :sticky-header="isStickyHeader"
          :dark="dark"
          :filter="filter"
          :items="questions"
          :fields="fields"
        >
          <template #cell(modifier)="row">
            <b-button
              @click="openQuestionModal(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="warning"
            >
              Editer
            </b-button>
          </template>
          <template #cell(dupliquer)="row">
            <b-button
              @click="duplicateQuestion(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="info"
            >
              Dupliquer
            </b-button>
          </template>
          <template #cell(supprimer)="row">
            <b-button
              @click="removeQuestionAlert(row.item)"
              class="mb-1 pr-3 pl-3"
              variant="danger"
            >
              Supprimer
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!-- Modals -->

    <ModalCategories />

    <ModalVerification
      v-if="isShowModal"
      :editItem="editItem"
      :duplicItem="duplicItem"
    ></ModalVerification>

    <ModalComposant
      v-if="isComponentModalShow"
      :editComponent="editComponent"
    ></ModalComposant>

    <vue-simple-context-menu
      :elementId="'myFirstMenu'"
      :options="optionsArray"
      ref="vueSimpleContextMenu"
      @option-clicked="openComponentModal"
    >
    </vue-simple-context-menu>
  </b-container>
</template>

<script>

import ModalVerification from "./ModalVerification";
import ModalComposant from "./ModalComposant";
import ModalCategories from "./ModalCategories";

import "vue-simple-context-menu/dist/vue-simple-context-menu.css";

export default {
  name: "VerificationsTable",
  props: {
    isDisconnected: Boolean,
  },
  components: {
    ModalVerification,
    ModalComposant,
    ModalCategories
  },
  data() {
    return {
      optionsArray: [
        {
          name: "Modifier",
          slug: "Modifier",
        },
      ],
      isShowModal: false,
      isComponentModalShow: false,
      editComponent: {},
      items: {},
      editItem: {},
      duplicItem: {},
      questions: [],
      building: {},
      usage: {},
      component: {},
      technology: {},
      buildings: [],
      usages: [],
      technologies: [],
      components: [],
      windowHeight: window.innerHeight - 160,
      isStickyHeader: window.innerHeight - 160 + "px",
      dark: true,
      filter: "",
      fields: [
        {
          key: "id",
          sortable: true,
        },
          {
          key: "cat",
          label: "Catégorie",
          sortable: true,
        },
        {
          key: "question",
          label: "Vérification",
          sortable: true,
        },
        {
          key: "modifier",
          sortable: true,
        },
        {
          key: "dupliquer",
          sortable: true,
        },
        {
          key: "supprimer",
          sortable: true,
        },
     
        {
          key: "active",
          label: "Publié",
          sortable: true,
        },
        {
          key: "validate",
          label: "Validé",
          sortable: true,
        },
        {
          key: "equipment",
          label: "Equipement",
          sortable: true,
        },
        {
          key: "help",
          label: "Aide",
          sortable: true,
        },

        {
          key: "answerType",
          label: "Type réponse",
          sortable: true,
        },
        // {
        //   key: "autoReference",
        //   label: "Autoréférence",
        //   sortable: true,
        // },
        {
          key: "comment",
          label: "Commentaire",
          sortable: true,
        },
        {
          key: "displayOrder",
          label: "Ordre affichage",
          sortable: true,
        },
        {
          key: "properties.orderNumber",
          label: "N° ordre",
          sortable: true,
        },
        {
          key: "updatedAt",
          label: "Mise à jour le",
          sortable: true,
        },
        {
          key: "lastModification",
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    if (this.localStorage.token) {
      this.token = this.localStorage.token;
    }
    this.getAll();

    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-question") {
        this.isShowModal = false;
        this.getAll();
      }
      if (modalId === "modal-component") {
        this.isComponentModalShow = false;
      }
    });

    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight - 120;
    });
  },
  methods: {
    handlerRightClick(event, component) {
      this.$refs.vueSimpleContextMenu.showMenu(event, component);
    },
    openComponentModal(event) {
      this.editComponent = event.item;

      this.isComponentModalShow = true;
      setTimeout(() => {
        this.$bvModal.show("modal-component");
      }, 100);
    },
    disconnect() {
      // this.showComponent();
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      this.token = null;
      this.isDisconnected = true;
    },
    getAll() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        // body: JSON.stringify({
        //   // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {

          // if (json.error?.statusCode === 500) {
          //   this.disconnect();
          // }

          this.questions = json.questions
            .map((item) => {
              item.displayOrder = item.properties?.displayOrder;
              item.updatedAt = new Date(item.updatedAt).toLocaleString();

              return { ...item };
            })
            .sort((a, b) => {
              return a.id - b.id;
            });

          // this.usages = json.usage.map((item) => {
          //   item.value = item;
          //   item.text = item.name;
          //   return { ...item };
          // });

          this.components = json.component.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });
        })
        .catch((err) => {
          console.log(err);
          this.disconnect();
        });
    },
    getQuestionsByComponent() {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/getQuestionsByComponent",
        {
          method: "POST",
          body: JSON.stringify({
            componentId: this.component.id,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          // console.log(json);
          this.questions = json;
        });
    },
    removeQuestion(id) {
      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/component/removeQuestion",
        {
          method: "POST",
          body: JSON.stringify({
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      ).then((resp) => {
        console.log(resp);
        if (resp.status === 200) {
          this.questions = this.questions.filter((item) => item.id !== id);
        }
      });
    },
    selectComponent(component) {
      this.component = component;
      this.getQuestionsByComponent();
    },
    stickyHeader() {
      if (!this.isStickyHeader) {
        this.isStickyHeader = this.windowHeight + "px";
      } else {
        this.isStickyHeader = false;
      }
    },
    openQuestionModal(item) {
      item
        ? ((this.editItem = item), (this.duplicItem = null))
        : ((this.editItem = null), (this.duplicItem = null));

      this.isShowModal = true;
      setTimeout(() => {
        this.$bvModal.show("modal-question");
      }, 100);
    },
    duplicateQuestion(item) {
      console.log(item);

      item
        ? ((this.duplicItem = item), (this.editItem = null))
        : ((this.editItem = null), (this.duplicItem = null));

      this.isShowModal = true;
      setTimeout(() => {
        this.$bvModal.show("modal-question");
      }, 100);
    },
    removeQuestionAlert(item) {
      console.log(item);
      this.$bvModal
        .msgBoxConfirm(
          "Etes-vous sûr de vouloir supprimer cette vérification ?",
          {
            title: "Veulliez confirmer",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NON",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((resp) => {
          if (resp) {
            this.removeQuestion(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
          // An error occurred
        });
    },
  },
  watch: {
    isDisconnected(newProps) {
      console.log(newProps);
      if (newProps) {
        this.token = false;
      }
    },
  },
  computed: {
    style() {
      return {
        top: this.top + "px",
        left: this.left + "px",
      };
    },
  },
};
</script>
<style>
.context-menu {
  position: fixed;
  background: white;
  z-index: 999;
  outline: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}
</style>
